import React from "react";

export default function SectionLabel({ children, index }) {
  return (
    <div className="flex items-center gap-3 label" data-testid="section-label">
      {index && <span className="font-mono tabular-nums">{index}</span>}
      <span className="w-8 h-px bg-[color:var(--ink)]/40" />
      <span>{children}</span>
    </div>
  );
}
